/* import __COLOCATED_TEMPLATE__ from './magnifying-glass.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, set } from '@ember/object';
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';

/**
## Svgs::MagnifyingGlass

Displays an SVG of a magnifying glass. Black lines on transparent background.

### Example usage
hbs```
  <Svgs::MagnifyingGlass
    @isFocused={{isFocused}}
  />
```
*/

const DEFAULT_ICON_HEX = '#b3b3b3';
const MARKET_BLUE_HEX = '#006AFF';
let MagnifyingGlass = (_dec = computed('_defaultColor', 'isFocused'), _class = class MagnifyingGlass extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", 20);
    _defineProperty(this, "width", 20);
    _defineProperty(this, "viewBox", '0 0 20 20');
    _defineProperty(this, "isFocused", false);
    _defineProperty(this, "fill", 'none');
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
  get defaultColor() {
    if (this._defaultColor !== undefined) {
      return this._defaultColor;
    }
    return this.isFocused ? MARKET_BLUE_HEX : DEFAULT_ICON_HEX;
  }
  set defaultColor(value) {
    set(this, '_defaultColor', value);
  }
}, _applyDecoratedDescriptor(_class.prototype, "defaultColor", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "defaultColor"), _class.prototype), _class);
export { MagnifyingGlass as default };